module.exports = "https://images.shiksha.ws/saassets/media/right_panel_bg.812fe3e2.jpg";